// extracted by mini-css-extract-plugin
export default {"wrapper":"Rv-z","button":"Sv-z","alternate":"Tv-z","disabled":"Uv-z","paymentWarning":"Vv-z","fadeIn":"Wv-z"};